









import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Alert extends Vue {
  @Prop()
  type!: string;

  @Prop()
  size!: string;

  get cssClass() {
    let modifier = "";
    let size = "";

    switch (this.type) {
      case "danger":
        modifier = `uc-alert--danger`;
        break;
      case "warning":
        modifier = `uc-alert--warning`;
        break;
      case "success":
        modifier = `uc-alert--success`;
        break;
    }

    switch (this.size) {
      case "small":
        size = `uc-alert--small`;
        break;
      case "large":
        size = `uc-alert--large`;
        break;
    }

    return `uc-alert ${modifier} ${size}`;
  }
}
